localStorage.removeItem("key");
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'


Vue.use(Router)

/**
 * name => 'tag标签中的title'
 * hideNav => 是否显示导航
 *
 */
let routes = [{
    path: '/',
    redirect: '/home',
},
{
    path: '/login',
    name: '登陆页',
    meta: {
        isLogin: true,
        hidden: true,
        hideNav: true,
        role: []
    },
    component: () =>
        import('@/login/login.vue')
},

{
    path: '/zhd/largeScreen',
    name: '项目工作看板',
    meta: {
        hideNav:true
    },
    component: () =>
        import('@/page/largeScreen/index.vue')
},
]

const router = new Router({
    routes,
})


router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token');
    console.log(to)
    if (to.meta.hideNav) {
        store.state.navShow = false
    } else {
        store.state.navShow = true
    }

    if (token || to.meta.hidden) { // 判断是否有token或不需要权限
        if (token && to.path === '/login') {
            next({
                path: '/home'
            })
        } else {
            next()
        }
    } else {
        next({
            path: '/login'
        });
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js